// Invoices (CONTEXT.md: Fee, Invoice, Issue, Pay, Overdue, Void, Refund).
export type InvoiceStatus = 'OUTSTANDING' | 'PAID' | 'VOIDED' | 'REFUNDED';
export type FeeCategory = 'TUITION' | 'TRIP' | 'OTHER';
export type IssueTarget = 'SCHOOL' | 'CLASS_YEAR' | 'CLASS' | 'STUDENT';

export const STATUS_TAGS: Record<InvoiceStatus, { label: string; color: string }> = {
  OUTSTANDING: { label: 'Төлөгдөөгүй', color: 'orange' },
  PAID: { label: 'Төлөгдсөн', color: 'green' },
  VOIDED: { label: 'Хүчингүй', color: 'default' },
  REFUNDED: { label: 'Буцаагдсан', color: 'purple' },
};

export const CATEGORY_LABEL: Record<FeeCategory, string> = {
  TUITION: 'Сургалтын төлбөр',
  TRIP: 'Аялал',
  OTHER: 'Бусад',
};

export const TARGET_LABEL: Record<IssueTarget, string> = {
  SCHOOL: 'Бүх сургууль',
  CLASS_YEAR: 'Анги (түвшин)',
  CLASS: 'Бүлэг',
  STUDENT: 'Сурагч',
};

export interface FeeOption {
  id: number;
  name: string;
  category: FeeCategory;
  amount: number;
  due_date: string | null;
  season_name: string | null;
}

export interface InvoiceRow {
  id: number;
  student_id: number;
  student_name: string | null;
  student_code: string | null;
  class_name: string | null;
  card_balance: number;
  fee_id: number;
  fee_name: string | null;
  category: FeeCategory | null;
  due_date: string | null;
  status: InvoiceStatus;
  overdue: boolean;
  amount: number;
  created_at: string;
  paid_at: string | null;
  note: string | null;
}

export interface InvoicePage {
  results: InvoiceRow[];
  total: number;
  totals: { paid: number; outstanding: number; refunded: number };
}

export interface IssuePreview {
  id: number;
  invoice_count: number;
  skip_count: number;
  items: {
    id: number;
    student_name: string | null;
    student_code: string | null;
    class_name: string | null;
    status: 'WILL_INVOICE' | 'SKIP';
    message: string | null;
  }[];
}

// One Idempotency key per user action: kept while it is retried, replaced
// once it succeeds (the server replays a repeated key instead of re-running).
export function newIdempotencyKey(): string {
  return crypto.randomUUID();
}
